import { useMsal } from "@azure/msal-react";
import { LOGIN_SCOPES } from "../../constants/auth.constant";
import chopLogo from "../../assets/chop_logo-2.svg";
import loginBg from "../../assets/login.webp";
import loginBgMobile from "../../assets/login-bg-mobile.png";
import microsoftLogo from "../../assets/microsoft_symbol.svg";
import AuthLayout from "../layout/auth-layout";
import { useIsMobile } from "@/hooks/use-mobile";

export const Login = () => {
  const { instance } = useMsal();
  const isMobile = useIsMobile();
  const background = isMobile ? loginBgMobile : loginBg;

  const login = () =>
    instance
      .loginRedirect({ scopes: LOGIN_SCOPES, redirectStartPage: "/" })
      .catch((e) => console.error("ERROR: Error occurred during user login", e));

  return (
    <AuthLayout backgroundUrl={background}>
      <div className="flex flex-col items-center justify-center text-center px-6 md:px-0 h-full">
        {/* Logo */}
        <div className="mb-6 md:mb-8">
          <img
            src={chopLogo}
            alt="Children's Hospital of Philadelphia"
            className="h-16 w-auto md:h-20 mx-auto"
          />
        </div>

        {/* Tagline */}
        <p className="text-gray-700 text-sm md:text-base mb-6 leading-relaxed font-secondary max-w-md md:max-w-xl p-6">
          At Children’s Hospital of Philadelphia, trust is the foundation of our
          relationship with you, our patients and families.
        </p>

        {/* Login Button */}
        <button
          onClick={login}
          aria-label="Login with SSO"
          className="flex items-center justify-center gap-2 px-6 py-2 rounded-md border border-gray-300 bg-white hover:bg-gray-100 transition-colors duration-200 shadow-sm"
        >
          <img src={microsoftLogo} alt="icon" className="w-5 h-5" />
          <span className="font-secondary text-gray-800 font-medium">
            Login with SSO
          </span>
        </button>
      </div>
    </AuthLayout>
  );
};
